module.exports = {
    dir_path:       '/home/calcwos/public_html/presenter/documents/customers',
    public_url:     'https://calc.worldofsolar.com/presenter/documents/customers',
    public_templates:     'https://calc.worldofsolar.com/presenter/documents/templates',
    template_path:  '/home/calcwos/public_html/presenter/documents/templates/pdf',
    font_path:       '/home/calcwos/public_html/presenter/documents/templates/fonts',
    left_margin:    '5px',
    right_margin:   '5px',
    top_margin:     '20px',
    bottom_margin:  '20px',
    years_per_page: 25,
    priv_discount:  610.00,
    phone_discount: 860.00,
    phone_discount_offer3: 375.00,
    phone_discount_offer4: 575.00,
    json_field_mappings: '/home/calcwos/json/pdf_field_mappings.json',
    customer_order_form:     'wos_order_template_v4.pdf',
    customer_order_form_norate:     'wos_order_template_v4_norate.pdf',
    customer_order_form_offgrid:     'wos_order_template_v4_offgrid.pdf',
    customer_order_form_batteryonly: 'wos_order_template_v4_batteryonly.pdf',
    minimum_price:  860.00,
    vat_rate:       0.00,
    commercial_vat_rate: 20.00,
    limitersize:    5000,
    customer_dno_form:     'dno_application_form.pdf',
    scaff_perside:  600,
    markup_rate:    1.29,
    // Live ADOBE
    adobetoken: '3AAABLblqZhCC5qDsVim-lXSGjaU2DceYPBf3z9z1-nUjlncvJS00JvDEc72i7bzaurkWaifYQm4Efc50T9qhYg7OEoCdaiC7',
    adobeurl: 'https://api.eu1.adobesign.com:443/api/rest/v6/agreements',
    // Test Mode Adobe
    //adobetoken: '3AAABLblqZhChtsjIC1Rny5B3DmRXT9CmwFB5_aZWSz525XKdnaKk-1OzSLXoyPPlWsuZFit77yrNTnj-gApdzjyMw4TaPEXu',
    //adobeurl: 'https://api.eu2.adobesign.com:443/api/rest/v6/agreements',
    dnos: [
        {id: 10,network: "UK Power Networks"},
        {id: 11,network: "Western Power Distribution"},
        {id: 12,network: "UK Power Networks"},
        {id: 13,network: "Scottish Power Energy Networks"}, 
        {id: 14,network: "Western Power Distribution"},
        {id: 15,network: "Northern Powergrid"}, 
        {id: 16,network: "Electricity North West"},
        {id: 17,network: "Scottish and Southern Energy"},
        {id: 18,network: "SP Energy Networks"},
        {id: 19,network: "UK Power Networks"},
        {id: 20,network: "Scottish and Southern Energy Power Distribution"},
        {id: 21,network: "Western Power Distribution"},
        {id: 22,network: "Western Power Distribution"},
        {id: 23,network: "Northern Powergrid"},
        {id: 24,network: "Independent Power Networks Ltd"},
        {id: 25,network: "ESP Electricity Limited"},
        {id: 26,network: "Energetics Electricity Ltd"},
        {id: 27,network: "The Electricity Network Company Ltd (GTC)"},
        {id: 28,network: "UK Power Networks (IDNO) Limited"}
    ],
    rep_sweep_commission: 100.00,
    manager_sweep_commission: 300.00,
    live_version: "2.290323.0C"
    
}